import {
    entityIdSchema,
    familyRoleSchema,
    ianaTimeZoneSchema,
    lengthDisplayUnitSchema,
    massDisplayUnitSchema,
    personNameSchema,
    utcInstantSchema,
    volumeDisplayUnitSchema,
} from '@baby-tracker/validation';
import { z } from 'zod';

import { successEnvelope } from './envelope.js';
import { API_BASE_PATH } from './routes.js';

export const FAMILIES_PATH = `${API_BASE_PATH}/families` as const;

export function familyPath(familyId: string): string {
    return `${FAMILIES_PATH}/${familyId}`;
}

export const familySchema = z.object({
    id: entityIdSchema,
    name: personNameSchema,
    timeZone: ianaTimeZoneSchema,
    unitVolume: volumeDisplayUnitSchema,
    unitMass: massDisplayUnitSchema,
    unitLength: lengthDisplayUnitSchema,
    role: familyRoleSchema,
    createdAt: utcInstantSchema,
    updatedAt: utcInstantSchema,
});

export type Family = z.infer<typeof familySchema>;

export const createFamilyInputSchema = z.object({
    name: personNameSchema,
    timeZone: ianaTimeZoneSchema,
    unitVolume: volumeDisplayUnitSchema.optional(),
    unitMass: massDisplayUnitSchema.optional(),
    unitLength: lengthDisplayUnitSchema.optional(),
});

export type CreateFamilyInput = z.infer<typeof createFamilyInputSchema>;

export const updateFamilyInputSchema = z
    .object({
        name: personNameSchema.optional(),
        timeZone: ianaTimeZoneSchema.optional(),
        unitVolume: volumeDisplayUnitSchema.optional(),
        unitMass: massDisplayUnitSchema.optional(),
        unitLength: lengthDisplayUnitSchema.optional(),
    })
    .refine((value) => Object.values(value).some((item) => item !== undefined), {
        message: 'At least one field is required',
    });

export type UpdateFamilyInput = z.infer<typeof updateFamilyInputSchema>;

export const familyResponseSchema = successEnvelope(familySchema);
export type FamilyResponse = z.infer<typeof familyResponseSchema>;
